import { createRouter, createWebHistory } from 'vue-router'
import AuthView from '../views/AuthView.vue'
import DashboardView from '../views/DashboardView.vue'
import AgentsView from '../views/AgentsView.vue'
import LLMsView from '../views/LLMsView.vue'
import KnowledgeBaseView from '../views/KnowledgeBaseView.vue'
import OrganizationsView from '../views/OrganizationsView.vue'
import UsersView from '../views/UsersView.vue'
import RolesView from '../views/RolesView.vue'
import IntegrationView from '../views/IntegrationView.vue'
import ApiDocView from '../views/ApiDocView.vue'
import WorkstreamsView from '../views/WorkstreamsView.vue'
import WorkstreamDetailView from '../views/WorkstreamDetailView.vue'
import TreasuryView from '../views/TreasuryView.vue'
import GovernanceView from '../views/GovernanceView.vue'
import ChatView from '../views/ChatView.vue'
import GoalDetailView from '../views/GoalDetailView.vue'
import CallbackView from '../views/CallbackView.vue'
import PublicPollView from '../views/PublicPollView.vue'
import store from '../store'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: AuthView
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView
  },
  {
    path: '/agents',
    name: 'agents',
    component: AgentsView
  },
  {
    path: '/models',
    name: 'models',
    component: LLMsView
  },
  {
    path: '/knowledge-base',
    name: 'knowledge-base',
    component: KnowledgeBaseView
  },
  {
    path: '/organizations',
    name: 'organizations',
    component: OrganizationsView
  },
  {
    path: '/users',
    name: 'users',
    component: UsersView
  },
  {
    path: '/roles',
    name: 'roles',
    component: RolesView
  },
  {
    path: '/integration',
    name: 'integration',
    component: IntegrationView
  },
  {
    path: '/api-docs',
    name: 'api-docs',
    component: ApiDocView
  },
  {
    path: '/workstreams',
    name: 'workstreams',
    component: WorkstreamsView
  },
  {
    path: '/treasury',
    name: 'treasury',
    component: TreasuryView
  },
  {
    path: '/governance',
    name: 'governance',
    component: GovernanceView
  },
  {
    path: '/callback',
    name: 'callback',
    component: CallbackView
  },
  {
    path: '/governance/polls/:id',
    name: 'public-poll',
    component: PublicPollView
  },
  {
    path: '/workstreams/:id',
    name: 'workstream-detail',
    component: WorkstreamDetailView
  },
   {
     path: '/tasks/:id',
     name: 'task-detail',
     component: ChatView
   },
  {
    path: '/goals/:id',
    name: 'goal-detail',
    component: GoalDetailView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  const publicPrefixes = ['/login', '/callback', '/governance/polls']
  const isPublic = publicPrefixes.some(p => to.path.startsWith(p))
  const authRequired = !isPublic
  const loggedIn = localStorage.getItem('token')

  // Handle authentication redirects
  if (authRequired && !loggedIn) {
    // Save the intended route to redirect after login
    return next({ 
      path: '/login', 
      query: { redirect: to.fullPath }
    })
  }

  // If logged in and trying to access login page, redirect to home
  if (loggedIn && to.path === '/login') {
    return next('/')
  }

  // Ensure user info is loaded before accessing protected routes
  if (authRequired && loggedIn && !store.state.auth.user) {
    try { await store.dispatch('auth/fetchUser') } catch (e) { /* ignore */ }
  }

  next()
})

export default router

